import { useMemo } from 'react';
import { getProxyUrl, getProxyUrls, getProxyUrlOrUrls } from '@shared/utils/proxy-url';

/**
 * Хук для преобразования URL'ов через прокси в режиме разработки
 * @param url - оригинальный URL
 * @returns преобразованный URL
 */
export const useProxyUrl = (url: string): string => {
  return useMemo(() => getProxyUrl(url), [url]);
};

/**
 * Хук для преобразования массива URL'ов через прокси в режиме разработки
 * @param urls - массив оригинальных URL'ов
 * @returns массив преобразованных URL'ов
 */
export const useProxyUrls = (urls: string[]): string[] => {
  return useMemo(() => getProxyUrls(urls), [urls]);
};

/**
 * Хук для преобразования URL или массива URL'ов через прокси в режиме разработки
 * @param urlOrUrls - URL или массив URL'ов
 * @returns преобразованный URL или массив URL'ов
 */
export const useProxyUrlOrUrls = (urlOrUrls: string | string[]): string | string[] => {
  return useMemo(() => getProxyUrlOrUrls(urlOrUrls), [urlOrUrls]);
};
